import { FC, useEffect, useRef, useState } from 'react';

import ContentCard from './ContentCard';
import GuideChanger from './GuideChanger';
import ProgressBar from './ProgressBar';
import ReviewCard from './ReviewCard';

import { BusinessType } from '@/lib/types/request';

interface Props {
  businessType: BusinessType;
  hasPhoneNumber: boolean;
  percent: number;
}
type LookupRequestViewProps = Props;

const totalCardCount = 10;

const delayTime = 4000;

const LookupRequestView: FC<LookupRequestViewProps> = ({ businessType, hasPhoneNumber, percent }) => {
  const interval = useRef<ReturnType<typeof setInterval> | null>(null);
  const selectedIndex = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isStarted = percent > 0;

  useEffect(() => {
    if (!isStarted) return;
    interval.current = setInterval(() => {
      selectedIndex.current = (selectedIndex.current + 1) % totalCardCount;
      setCurrentIndex(selectedIndex.current);
    }, delayTime);

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }
    };
  }, [isStarted]);

  return (
    <div className="flex h-[calc(100vh-100px)] items-center justify-center page-padding">
      <div className="flex flex-col w-full">
        <GuideChanger businessType={businessType} isStarted={isStarted} hasPhoneNumber={hasPhoneNumber} isLastStep={percent >= 98} />
        <ProgressBar percent={percent} />
        <div className="relative mt-10 mb-[200px]">
          {isStarted && (
            <>
              <ContentCard cardIndex={0} isShow={currentIndex === 0} />
              <ReviewCard cardIndex={0} isShow={currentIndex === 1} />
              <ReviewCard cardIndex={1} isShow={currentIndex === 2} />

              <ContentCard cardIndex={1} isShow={currentIndex === 3} />
              <ReviewCard cardIndex={2} isShow={currentIndex === 4} />
              <ReviewCard cardIndex={3} isShow={currentIndex === 5} />

              <ContentCard cardIndex={2} isShow={currentIndex === 6} />
              <ReviewCard cardIndex={4} isShow={currentIndex === 7} />
              <ReviewCard cardIndex={5} isShow={currentIndex === 8} />
              <ReviewCard cardIndex={6} isShow={currentIndex === 9} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LookupRequestView;
